import React, { useContext } from 'react';
import _noop from 'lodash/noop';

import { ModalContext, CustomFooter } from 'commons-ui';

import { ACTION_IDS, BUTTON_LABELS } from './constants';
import { RejectContent, SubmitKyc } from './components';
import useHandler from './useHandler';

export const makeActionHandler = (actionId: string, params: any) => {
	const { setModalConfig } = useContext(ModalContext);
	const { handleForceUpdate = _noop, kycId } = params;
	const { onAgreeApproveKyc, onDisAgreeApproveKyc } = useHandler({ handleForceUpdate, kycId });

	switch (actionId) {
		case ACTION_IDS.APPROVE:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'KYC Approval',
					content: 'Are you sure you want to approve kyc of the user ?',
					footer: (
						<CustomFooter
							agreeLabel={BUTTON_LABELS.APPROVE_AGREE}
							disagreeLabel={BUTTON_LABELS.APPROVE_DISAGREE}
							onAgreeClick={onAgreeApproveKyc}
							onDisagreeClick={onDisAgreeApproveKyc}
						/>
					)
				});
			};
		case ACTION_IDS.REJECT:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'KYC Rejection',
					content: <RejectContent handleForceUpdate={handleForceUpdate} kycId={kycId} />
				});
			};
		case ACTION_IDS.UPLOAD:
			return () => {
				setModalConfig({
					isOpen: true,
					header: 'Upload KYC Documents',
					content: <SubmitKyc handleForceUpdate={handleForceUpdate} kycId={kycId} />
				});
			};
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
